import React from 'react';
import tw from 'twin.macro';
import { ItemSummary } from './';

export const ItemContent = ({ item, landscape = false, isSidebar }) => {
  return (
    <>
      <div css={[tw`flex-grow px-4`, landscape && tw`p-2 px-3`, isSidebar && tw`pr-0`]}>
        <ItemSummary item={item} isSidebar={isSidebar} />
      </div>
    </>
  );
};
